export default "__VITE_ASSET__DTyaTwBh__"